<script>
  import { format } from 'svelte-i18n';

  import { Field, FieldActions, FieldHeader, FieldLabel, FieldValue } from '@client/components/fields/standalone/base';

  import { GroupSelector } from './group-selector';

  export let id = null;
  export let label = null;
  export let value = {};

  export let tooltip = undefined;
  export let tooltipIcon = undefined;

  export let readonly = false;
  export let editing = false;

  export let showActions = true;

  export let onUpdate = () => {};

  let selectedValues = {
    ...value
  };

  const onEdit = () => {
    editing = true;
  };

  const onCancel = () => {
    editing = false;
    selectedValues = { ...value };
  };

  const onSave = () => {
    editing = false;

    if (onUpdate) {
      const groupedSelectedIds = Object.entries(selectedValues).reduce((acc, [key, value]) => {
        acc[key] = value.map(({ value }) => ({ id: value }));
        return acc;
      }, {});

      selectedValues = Object.entries(selectedValues).reduce((acc, [key, value]) => {
        acc[key] = value.map(({ label, total }) => `${label} (${total})`);
        return acc;
      }, {});

      value = { ...groupedSelectedIds };

      if (onUpdate) {
        onUpdate(id, label, groupedSelectedIds);
      }
    }
  };

  const onChange = (items, field) => {
    const type = items && items[0]?.type;

    if (!type) {
      selectedValues[field] = [];
      return;
    }

    if (type) {
      selectedValues[type] = items;
      selectedValues = { ...selectedValues };
    }
  };
</script>

<Field bind:editing>
  <FieldHeader>
    <FieldLabel {label} {tooltipIcon} {tooltip} />
    <FieldActions bind:readonly bind:editing {onSave} {onEdit} {onCancel} {showActions} disableSubmit={false} />
  </FieldHeader>
  <FieldValue {showActions}>
    {#if editing}
      <div class="groups">
        <b>{$format('label.GOOGLE_GROUPS')}</b>
        <div class="field-select">
          <GroupSelector bind:config={value} field="googlegroupbindings" {onChange} />
        </div>

        <b>{$format('label.MICROSOFT_GROUPS')}</b>
        <div class="field-select">
          <GroupSelector bind:config={value} field="o365groupbindings" {onChange} />
        </div>

        <b>{$format('label.OKTA_GROUPS')}</b>
        <div class="field-select">
          <GroupSelector bind:config={value} field="oktagroupbindings" {onChange} />
        </div>
      </div>
    {:else}
      {#if selectedValues.googlegroupbindings.length}
        {$format('label.GOOGLE')}: <GroupSelector bind:config={value} field="googlegroupbindings" readOnly />
      {/if}

      {#if selectedValues.o365groupbindings.length}
        {$format('label.MICROSOFT_365')}: <GroupSelector bind:config={value} field="o365groupbindings" readOnly />
      {/if}

      {#if selectedValues.oktagroupbindings.length}
        {$format('label.OKTA')}: <GroupSelector bind:config={value} field="oktagroupbindings" readOnly />
      {/if}

      {#if !selectedValues.googlegroupbindings.length && !selectedValues.o365groupbindings.length && !selectedValues.oktagroupbindings.length}
        -
      {/if}
    {/if}
  </FieldValue>
  {#if !editing}
    <slot />
  {/if}
</Field>

<style lang="scss" src="./role-bindings.scss"></style>
